import _parseInt from 'lodash/parseInt';
import APPCONFIG from '../../constants/Config';
import {
  REINIT_STATE,
  GET_SIMCARD_GROUPS_LIST,
  GET_SIMCARD_GROUPS_LIST_SUCCESS,
  GET_SIMCARD_GROUPS_LIST_ERROR,
  ADD_SIMCARD_GROUP,
  ADD_SIMCARD_GROUP_SUCCESS,
  ADD_SIMCARD_GROUP_ERROR,
  GET_SIMCARD_GROUP,
  GET_SIMCARD_GROUP_SUCCESS,
  GET_SIMCARD_GROUP_ERROR,
  ADD_SIMCARD_GROUP_APN,
  ADD_SIMCARD_GROUP_APN_SUCCESS,
  ADD_SIMCARD_GROUP_APN_ERROR,
  DELETE_SIMCARD_GROUP_APN,
  DELETE_SIMCARD_GROUP_APN_SUCCESS,
  DELETE_SIMCARD_GROUP_APN_ERROR,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserializeGroup } from '../../models/simcard';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.simcardGroup;
const simcardGroup = (state = initialSettings, action) => {
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      if (action.target === 'fullSimcard') {
        return {
          ...state,
          list: { ...initialSettings.list },
          add: { ...initialSettings.add },
          current: { ...initialSettings.current },
          addApn: { ...initialSettings.addApn },
          deleteApn: { ...initialSettings.deleteApn },
        };
      }
      return state;
    // LIST
    case GET_SIMCARD_GROUPS_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          error: null,
          elements: {
            ...state.list.elements,
            data: null,
          },
        },
      };
    case GET_SIMCARD_GROUPS_LIST_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: action.error,
        },
      };
    case GET_SIMCARD_GROUPS_LIST_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          elements: {
            ...state.list.elements,
            data: deserializeGroup(action.data.data),
            pageNumber: _parseInt(action.data.page_number),
            pageSize: _parseInt(action.data.page_size),
            totalEntries: _parseInt(action.data.total_entries),
            totalPages: _parseInt(action.data.total_pages),
          },
        },
      };
    // ADD
    case ADD_SIMCARD_GROUP:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          error: null,
        },
      };
    case ADD_SIMCARD_GROUP_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
        },
      };
    case ADD_SIMCARD_GROUP_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
        },
      };
    // GET
    case GET_SIMCARD_GROUP:
      return {
        ...state,
        current: {
          ...state.current,
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_SIMCARD_GROUP_ERROR:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: action.error,
        },
      };
    case GET_SIMCARD_GROUP_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          data: deserializeGroup(action.data.data),
        },
      };
    // ADD APN
    case ADD_SIMCARD_GROUP_APN:
      return {
        ...state,
        addApn: {
          ...state.addApn,
          added: false,
          error: null,
        },
      };
    case ADD_SIMCARD_GROUP_APN_ERROR:
      return {
        ...state,
        addApn: {
          ...state.addApn,
          error: action.error,
        },
      };
    case ADD_SIMCARD_GROUP_APN_SUCCESS:
      return {
        ...state,
        addApn: {
          ...state.addApn,
          added: true,
        },
      };
    // DELETE APN
    case DELETE_SIMCARD_GROUP_APN:
      return {
        ...state,
        deleteApn: {
          ...state.deleteApn,
          deleted: false,
          error: null,
        },
      };
    case DELETE_SIMCARD_GROUP_APN_ERROR:
      return {
        ...state,
        deleteApn: {
          ...state.deleteApn,
          error: action.error,
        },
      };
    case DELETE_SIMCARD_GROUP_APN_SUCCESS:
      return {
        ...state,
        deleteApn: {
          ...state.deleteApn,
          deleted: true,
        },
      };
    default:
      return state;
  }
};

export default simcardGroup;



// WEBPACK FOOTER //
// ./reducers/simcard/simcardGroup.js